import { Plugin } from 'rainbow-web-sdk/plugins/plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { DataChannelService_RB } from '../services/dataChannel/dataChannel.service';
import { LiveTranscriptionServiceRB } from '../services/transcription/liveTranscription.service';

export class TranscriptionPlugin extends Plugin {
    public static initialize(): TranscriptionPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[TranscriptionPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[TranscriptionPlugin] initialized");
            window.rainbow.plugins[TranscriptionPlugin.name] = new TranscriptionPlugin();
            DataChannelService_RB.getInstance();
            LiveTranscriptionServiceRB.getInstance();
        }

        return window.rainbow.plugins[TranscriptionPlugin.name];
    }

    private constructor() {
        super();
    }
}
